import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThumbnailCharactersComponent } from '../thumbnail-characters/thumbnail-characters.component';
import { ThumbnailComponent } from '../thumbnail/thumbnail.component';

@Component({
  selector: 'osp-dynamic-thumbnail',
  standalone: true,
  imports: [ThumbnailComponent, ThumbnailCharactersComponent],
  templateUrl: './dynamic-thumbnail.component.html',
  styleUrl: './dynamic-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicThumbnailComponent {
  @Input() thumbnailLetter?: string = '';
  @Input() thumbnailKey?: string = '';
  @Input() directImage: boolean = false;
  @Input() customerId: string | undefined;
}
